<ngx-smart-modal
    customClass="speakerModal"
    [backdrop]="true"
    #myModal
    identifier="myModal"
    (onAnyCloseEventFinished)="onModalClose()"
    (onOpen)="onModalOpen()"
>
    <div *ngIf="myModal.hasData()">
        <div [innerHTML]="myModal.getData().speakerModalHeader | safeHtml"></div>
        <div
            [ngClass]="{
                'speaker-catalog-body-region': true,
                'attendee-session-list-container': speakerConfig.layout != 'l_banner'
            }"
            [innerHTML]="myModal.getData().modalContent | safeHtml"
        ></div>
        <div *ngIf="bindSpeakerClick && viewSpeakerSessionList"><div *ngIf="bindClick()"></div></div>
    </div>
</ngx-smart-modal>

<ngx-smart-modal
    customClass="sessionModal"
    [backdrop]="true"
    #sessionModal
    identifier="sessionModal"
    (onAnyCloseEvent)="onSessionModalClose()"
>
    <div>
        <div [innerHTML]="sessionModal?.getData()?.sessionModalHeader | safeHtml"></div>
        <div
            [ngClass]="{
                'general-session-catalog-body-region': (styleType==='general' && (sharedService.catalogLayoutConfig.promotedStyle == 'card' || sharedService.catalogLayoutConfig.highlightedStyle == 'card' || sharedService.catalogLayoutConfig.generalStyle == 'card')),
                'highlighted-session-catalog-body-region': (styleType==='highlighted' && (sharedService.catalogLayoutConfig.promotedStyle == 'card' || sharedService.catalogLayoutConfig.highlightedStyle == 'card' || sharedService.catalogLayoutConfig.generalStyle == 'card'))

            }"
        >
    <div #vc></div>
    </div>
        <!-- <div *ngIf="bindSpeakerClick && viewSpeakerSessionList"><div *ngIf="bindClick()"></div></div> -->
    </div>
</ngx-smart-modal>

<ngx-smart-modal customClass="instanceModal" [backdrop]="true" #instanceModal identifier="instanceModal">
    <div class="all-instance-modal" *ngIf="instanceModal.hasData()">
        <div [innerHTML]="instanceModal.getData().modalContent | safeHtml"></div>
    </div>
</ngx-smart-modal>
<div
    *ngIf="sharedService.catalogLayoutConfig.listType === 'magazine'"
    class="highlighted-list-section"
    [hidden]="
        highlightedDataConfig.selectedList == null ||
        highlightedDataConfig.selectedList.length <= 0 ||
        noHighLightedSessions
    "
>
    <h4 [ngClass]="'highlighted-session-label'">
        {{ highlightedSessionConfig.labelConfig.label }}
        <i class="fa fa-chevron-circle-down" *ngIf="!showHighlighted" title="Show Highlighted" (cclClick)="toggleHighlighted()"></i>
        <i class="fa fa-chevron-circle-right" *ngIf="showHighlighted" title="Hide Highlighted" (cclClick)="toggleHighlighted()"></i>
    </h4>

    <div [ngClass]="{ 'show-carousel': !showHighlighted, 'hide-carousel': showHighlighted }">
        <div #highlightedList>
            <div *ngIf="!showHighlighted && showCarousel && highlightedDataConfig.displayAs === '1_carousel'">
                <ngx-slick-carousel class="carousel" #highlighted="slick-carousel" [config]="slideConfig">
                    <div ngxSlickItem *ngFor="let slide of highlightedCarousel" class="slide">
                        <div
                            [innerHTML]="slide.content | safeHtml"
                            [ngClass]="{
                                'cursor-pointer': true,
                                'highlighted-session-catalog-header-region': true,
                                'attendee-session-list-container': highlightedSessionConfig.layout != 'l_banner'
                            }"
                        ></div>
                    </div>
                </ngx-slick-carousel>
            </div>
        </div>
    </div>
</div>

<div>
    <div
        *ngIf="
            sharedService.catalogLayoutConfig.listType === 'magazine' ||
            sharedService.catalogLayoutConfig.listType === 'promoted'
        "
        class="promoted-list-section"
        [hidden]=" 
            promotedDataConfig.selectedList == null || promotedDataConfig.selectedList.length <= 0 || noPromotedSessions
        "
    >
        <h4 [ngClass]="'promoted-session-label'">
            {{ promotedSessionConfig.labelConfig.label }}
            <i class="fa fa-chevron-circle-down" *ngIf="!showPromoted" title="Show Promoted" (cclClick)="togglePromoted()"></i>
            <i class="fa fa-chevron-circle-right" *ngIf="showPromoted" title="Hide Promoted" (cclClick)="togglePromoted()"></i>
        </h4>
        <div id="promotedCarouselDiv" [ngClass]="{ 'hide-carousel': showPromoted, 'show-carousel': !showPromoted }">
            <div #promotedList>
                <div *ngIf="!showPromoted && showCarousel && promotedDataConfig.displayAs === '1_carousel'">
                    <ngx-slick-carousel class="carousel" #promoted="slick-carousel" [config]="slideConfig">
                        <div ngxSlickItem *ngFor="let slide of promotedCarousel" class="slide">
                            <div
                                [innerHTML]="slide.content | safeHtml"
                                [ngClass]="{
                                    'cursor-pointer': true,
                                    'promoted-session-catalog-header-region': true,
                                    'attendee-session-list-container': promotedSessionConfig.layout != 'l_banner'
                                }"
                            ></div>
                        </div>
                    </ngx-slick-carousel>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="noSessionsInCatalog && esPage == 0 && noHighLightedSessions && noPromotedSessions; else showData">
    <span id="no-session-catalog-label"> {{ 'session_section.no_session' | translate }} </span>
</div>
<ng-template #showData>
    <div class="general-list-section">
        <h4 [ngClass]="'general-session-label'">
            {{ generalSessionConfig.labelConfig.label }}
        </h4>
        <div class="attendee-session-list-text-filter">
            <div class="c-form-group">
                <div class="input-group" *ngIf="!generalSessionConfig?.catalogConfig?.hasOwnProperty('showSearchBar') || generalSessionConfig?.catalogConfig?.showSearchBar == true">
                    <input
                        aria-label="Search Sessions"
                        cclFormInput
                        id="general-list-search-label"
                        role="textbox"
                        type="text"
                        [(ngModel)]="sessionFilter.query"
                        class="c-form-group__input form-control"
                        placeholder="{{generalSessionConfig?.catalogConfig?.searchBarText}}"
                        (keyup.enter)="clickTextSearch()"
                    />
                    <div
                        class="input-group-append"
                        *ngIf="sessionFilter.query"
                        (cclClick)="clickRemoveFilter()"
                        title="Clear Filters"
                    >
                        <span class="c-color-picker input-group-text"><i class="fa fa-close" role="presentation"></i></span>
                    </div>

                    <div class="input-group-append" (cclClick)="clickTextSearch()" title="Search">
                        <span class="c-color-picker input-group-text"><i class="fa fa-search" role="presentation"></i></span>
                    </div>
                </div>
                <div class="c-form-group__hint">&nbsp;</div>
            </div>
            <div class="general-list-loader">
                <img
                    alt="Loading..."
                    *ngIf="sharedService.generalListLoading && esPage == 0"
                    src="assets/images/loading.gif"
                />
            </div>
        </div>
        <div infiniteScroll [infiniteScrollDistance]="1" [infiniteScrollThrottle]="50" (scrolled)="onScroll()">
            <div #generalList id="generalList"></div>
            <div class="general-list-loader">
                <img
                    alt="Loading..."
                    *ngIf="!sharedService.showLoader && loadingList && esPage > 0"
                    src="assets/images/loading.gif"
                />
            </div>
            <div
                id="no-records-found-label"
                *ngIf="!loadingList && !noSessionsInCatalog && noSessionsAvailable && filterResults && esPage == 0"
            >
                {{ 'session_section.no_record_found' | translate }}
            </div>
            <div id="no-records-found-label" *ngIf="noSessionsInCatalog">
                {{ 'session_section.no_record_found' | translate }}
            </div>
            <div
                *ngIf="
                    !noSessionsInCatalog &&
                    noSessionsAvailable &&
                    filterResults &&
                    esPage > 0 &&
                    sharedService.allSessionsHidden
                "
                id="no-more-records-found-label"
            >
            {{ 'session_section.no_more_records_found' | translate }}
            </div>
        </div>
    </div>
</ng-template>
